// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbc076ce","455":"417ebc9a","977":"5cca2e42"}[chunkId] + ".chunk.js";
};